import "core-js/modules/es.array.map";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export var isSameDay = function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.clone().startOf('day').isSame(moment2.clone().startOf('day'));
  } else {
    return !moment1 && !moment2;
  }
};
export var isDayWeekday = function isDayWeekday(day) {
  return day.isoWeekday() <= 5;
};
export var isDayWeekend = function isDayWeekend(day) {
  return !isDayWeekday(day);
};
export var getDateFromUTCString = function getDateFromUTCString(utcString) {
  return new Date(Date.parse(utcString));
};
export var getTimezoneAbbreviation = function getTimezoneAbbreviation(_ref) {
  var date = _ref.date,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-us' : _ref$locale;
  return date.toLocaleTimeString(locale, {
    timeZoneName: 'short'
  }).split(' ')[2];
};

var dayNames = function dayNames(getString) {
  return [getString('global.days.sunday'), getString('global.days.monday'), getString('global.days.tuesday'), getString('global.days.wednesday'), getString('global.days.thursday'), getString('global.days.friday'), getString('global.days.saturday')];
};

var monthNames = function monthNames(getString) {
  return [getString('global.months.january'), getString('global.months.february'), getString('global.months.march'), getString('global.months.april'), getString('global.months.may'), getString('global.months.june'), getString('global.months.july'), getString('global.months.august'), getString('global.months.september'), getString('global.months.october'), getString('global.months.november'), getString('global.months.december')];
};

export var daysOfWeek = function daysOfWeek(getString) {
  return dayNames(getString).map(function (dayName) {
    return {
      name: dayName,
      abbreviation: dayName.substring(0, 3)
    };
  });
};
export var months = function months(getString) {
  return monthNames(getString).map(function (month) {
    return {
      name: month,
      abbreviation: month.substring(0, 3)
    };
  });
};